<template>
  <div id="progression-bar" class="inline space-between top" :class="[$mq, {TA:isTestAchat}]" :key="$route.name">
    <div class="separator">
      <span :style="{ width: progression }"></span>
    </div>
    <div
      class="step"
      :class="{active: active(step), 'done': done(step)}"
      v-for="step in steps"
      :key="step"
    >
      <div class="badge">
        <SvgIcon class="icon" :icon="`step-${icon(step)}`" fill></SvgIcon>
      </div>
      <!-- <div class="indicator">{{ step }}</div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters("subscription", ["isTestAchat"]),
    stepRoutes() {
      return this.$router.options.routes.find(route => route.name === 'Default').children;
    },
    progressionWeight() {
      let weight = {};
      let progression = 0;

      let routes = this.stepRoutes.filter(route => route.progressionBar);

      // Clone routes
      let steps = [...routes];

      // Compute step weight
      let stepWeight = 100 / steps.length;

      steps.forEach((step) => {
        // If step has children, divide step weight for each child
        if (step.children !== undefined) {
          step.children.forEach((child) => {
            if (child.name !== undefined) {
              let pageWeight = stepWeight / step.children.length;
              progression = progression + pageWeight;
              weight[child.name] = progression;
            }
          });
        } else {
          progression = progression + stepWeight;
          weight[step.name] = progression;
        }
      });

      return weight;
    },
    steps() {
      let steps = [];

      this.stepRoutes.forEach((route) => {
        if (route.progressionBar) steps.push(route.name);
      });

      return steps;
    },
    pages() {
      let pages = [];

      this.stepRoutes.forEach((route) => {
        if (route.progressionBar) {
          if (route.children === undefined) pages.push(route.name);

          if (route.children !== undefined) {
            route.children.forEach((child) => {
              if (child.name !== undefined) pages.push(child.name);
            });
          }
        }
      });

      return pages;
    },
    step() {
      return this.$route.matched ? this.$route.matched[1].name : "Situation";
    },
    page() {
      let page = "PersonalDetails";

      if (this.$route.matched) {
        page =
          this.$route.matched.length > 2
            ? this.$route.matched[2].name
            : this.$route.matched[1].name;
      }
      return page;
    },
    progression() {
      let percentage = this.progressionWeight[this.page];

      return `${percentage}%`;
    },
  },
  methods: {
    active(step) {
      return this.step === step;
    },
    done(step) {
      let index = this.steps.indexOf(step);
      return this.steps.indexOf(this.step) > index;
    },
    icon(step) {
      return this.done(step) ? "done" : step;
    },
  },
};
</script>

<style lang="scss" scoped>
#progression-bar {
  margin: 20px;
  margin-bottom: 0;
  position: relative;

  &.desktop {
    margin: 10px auto;
    margin-bottom: 0;
    width: 700px;
  }

  .step {
    z-index: 0;

    .indicator {
      display: none;
      // margin-left: -40px;
    }

    .badge {
      height: 30px;
      width: 30px;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: $clearYellow;
      color: $black;
      font-size: 1.3rem;

      .icon {
        margin-top: -4px;
      }
    }

    &.active {
      .indicator {
        display: block;
      }
    }

    &.active,
    &.done {
      .badge {
        color: $black;
        background: $white;
      }
    }
  }

  .separator {
    position: absolute;
    top: 12px;
    width: 100%;
    height: 6px;
    background: $clearYellow;

    span {
      display: block;
      height: 100%;
      width: 60%;
      background: $white;
    }
  }

  &.TA {
    .badge {
        background: $white!important;
      }

      .separator {
        background-color: $white;

        span {
          background-color: $pink;
        }
      }
      .icon {
        color: $black!important;
        /deep/ svg {
          fill: $black;
        }
      }
    &.mobile,
    &.desktop {
      .step {
        &.done,
        &.active {
          .badge, .separator {
            background-color: $pink!important;
          }
          .icon {
            color: $white;

            /deep/ svg {
              fill: $white;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressionBar.vue